import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],

};

const importPreTextList = createSlice({
  name: "availableFileGridData",
  initialState,
  reducers: {
    updateImportPreTextList: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { updateImportPreTextList } = importPreTextList.actions;
export default importPreTextList.reducer;
